export default __webpack_public_path__ + "static/buildbox-a85f3d195abbc14a65ffcbe6482f8688.svg";